import styled from 'styled-components';

import { FontWeights, PrimaryButton } from '@calm-web/design-system';

import { Pack, PackCardItem } from '@/components/app/cards/PacksList/types';
import { usePackItemAttributes } from '@/hooks/app/usePackItemAttributes';
import playIcon from 'icons/play-filled.svg';

// 20px, on the real gap confirmed on the screen a Daily program actually reaches (both
// platforms redirect away from their generic per-type program-detail screen toward a
// packs-feed-driven one for real Daily content — verified by tracing the redirect
// destination on each, not just matching a same-named component). Android's
// PackItemDecorator has no special case for a paragraph-after-button pairing there, so it
// always falls to the plain 20dp pack_vertical_space; iOS's equivalent (its button pack's own
// 8pt bottom + the paragraph pack's own 8pt top) works out to 16pt. 20px splits the two.
const Wrapper = styled.div`
	margin-bottom: 20px;
`;

interface ButtonPackProps {
	pack: Pack;
	item: PackCardItem;
}

const ButtonPack = ({ pack, item }: ButtonPackProps) => {
	const { title, handlePackItemClick, key } = usePackItemAttributes({ pack, packItem: item });

	// usePackItemAttributes tags any item type it has no render branch for with this
	// sentinel key, so checking it here reuses that signal instead of re-deriving the
	// hook's own type checks.
	if (key === 'invalid-pack-item' || !title) {
		return null;
	}

	return (
		<Wrapper>
			<PrimaryButton
				backgroundColor="white"
				textColor="black"
				iconColor="black"
				Icon={playIcon}
				fullWidth
				maxWidth="480px"
				// Both platforms render this label at weight 600 (Android explicitly loads its
				// bold font file, not just a weight axis) — PrimaryButton's own default is
				// Medium (500); Demi (700) is this design system's closest match. Font size
				// already resolves to 18px at mobileLarge+ via FontSizes.base * 1.125rem,
				// matching both platforms' 18pt/18sp with no override needed.
				fontWeight={FontWeights.Demi}
				onPress={() => {
					handlePackItemClick().catch(() => {});
				}}
			>
				{title}
			</PrimaryButton>
		</Wrapper>
	);
};

export default ButtonPack;
